import React, { useState } from 'react';
import { fetchWebExercises, getExercises } from '../../utils/api';

const Crawler = () => {
    const [exercises, setExercises] = useState([]);
    const [loading, setLoading] = useState(false);

    const handleFetchFromWeb = async () => {
        setLoading(true);
        try {
            const fetchedExercises = await fetchWebExercises();
            const formattedExercises = fetchedExercises.savedExercises.map(ex => ({
                name: ex.name,
                muscleGroup: ex.muscleGroup,
                gif: ex.gifUrl
            }));
            setExercises(formattedExercises);
        } catch (error) {
            console.error('Error fetching from web:', error);
        }
        setLoading(false);
    };

    const handleGetExercises = async () => {
        setLoading(true);
        try {
            const data = await getExercises();
            const formattedData = data.map(exercise => ({
                name: exercise.name,
                muscleGroup: exercise.muscleGroup,
                gif: exercise.gifUrl
            }));
            setExercises(formattedData);
        } catch (error) {
            console.error('Error fetching exercises:', error);
        }
        setLoading(false);
    };

    return (
        <div style={{ padding: '20px', textAlign: 'center' }}>
            <h1>Exercise Crawler</h1>
            <button onClick={handleFetchFromWeb} disabled={loading}>
                {loading ? 'Fetching...' : 'Fetch Exercises from Web'}
            </button>
            <button onClick={handleGetExercises} disabled={loading}>
                {loading ? 'Loading...' : 'Show Stored Exercises'}
            </button>
            <div style={{ marginTop: '20px' }}>
                {exercises.length > 0 ? (
                    <ul style={{ listStyle: 'none', padding: 0 }}>
                        {exercises.map((exercise, index) => (
                            <li key={index} style={{ marginBottom: '20px' }}>
                                <strong>{exercise.name}</strong> ({exercise.muscleGroup})
                                <br />
                                {exercise.gif && (
                                    <img
                                        src={exercise.gif}
                                        alt={exercise.name}
                                        width="150"
                                        style={{ marginTop: '5px' }}
                                    />
                                )}
                            </li>
                        ))}
                    </ul>
                ) : (
                    <p>No exercises available. Try "Fetch Exercises from Web".</p>
                )}
            </div>
        </div>
    );
};

export default Crawler;